import React from "react"

class Contact extends React.Component {
    render() {
        return (
            <div>Let me get a dollar</div>
        )
    }
}

export default Contact
